// extracted by mini-css-extract-plugin
export var menuIcon = "_su-0";
export var menuIconInline = "_su-1";